
/**
 * 추가 메타데이터
 */
export type GetStreamingInfoByPath200MediaInfoMetadata = { [key: string]: unknown };
